const connectionInfoIconFactory = (item) => {
  return item;
};
const connectionInfoImageFactory = (item) => {
  return item;
};
const isConnectionInfoIcon = (item) => {
  return item.icon !== void 0;
};
const isConnectionInfoImage = (item) => {
  return item.image !== void 0;
};
const isDeviceConnectionType = (value) => {
  if (!value) return false;
  return [
    "IOS_DEVICE",
    "ANDROID_DEVICE"
  ].includes(value);
};

export { connectionInfoIconFactory, connectionInfoImageFactory, isConnectionInfoIcon, isConnectionInfoImage, isDeviceConnectionType };
//# sourceMappingURL=connections.utils.js.map
